import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    gtag: (...args: any[]) => void
    dataLayer: any[]
  }
}

const GA_MEASUREMENT_ID = 'G-9SMGV7LTLB'

export const GoogleAnalytics: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    // Initialize GA4
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    window.gtag = function gtag() {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    })
  }, [])

  useEffect(() => {
    // Track page views
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
    })
  }, [location])

  return null
}

export default GoogleAnalytics 